import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Plus, Minus } from "lucide-react";
import CustomBlocks from "@/components/site/CustomBlocks";

function Item({ q, a, id }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-[#E5DFD3]">
      <button data-testid={`faq-toggle-${id}`} onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-4 py-6 text-left">
        <span className="font-medium text-lg text-[#1A201D]">{q}</span>
        {open ? <Minus className="w-5 h-5 text-[#9A8C73] shrink-0" strokeWidth={1.5} /> : <Plus className="w-5 h-5 text-[#9A8C73] shrink-0" strokeWidth={1.5} />}
      </button>
      {open && <p className="pb-6 text-[#4A5550] leading-relaxed max-w-3xl" data-testid={`faq-answer-${id}`}>{a}</p>}
    </div>
  );
}

export default function Faq({ previewSite }) {
  const outlet = useOutletContext();
  const site = previewSite || outlet?.site;
  if (!site) return null;
  const p = site.pages.faq;
  return (
    <div data-testid="faq-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10 pt-20 pb-28">
        <p className="uppercase tracking-[0.2em] text-xs font-bold text-[#9A8C73] mb-5">{p.hero.eyebrow}</p>
        <h1 className="font-display text-5xl md:text-6xl font-semibold tracking-tight text-[#1A201D] mb-4">{p.hero.title}</h1>
        <p className="text-lg text-[#4A5550] mb-14">{p.hero.subtitle}</p>

        {p.groups.map((g, gi) => (
          <div key={gi} className="mb-12">
            <h2 className="font-display text-2xl font-semibold text-[#2C3531] mb-2">{g.title}</h2>
            <div>
              {g.items.map((it, ii) => <Item key={ii} q={it.q} a={it.a} id={`${gi}-${ii}`} />)}
            </div>
          </div>
        ))}
      </div>
      <CustomBlocks blocks={p.blocks} />
    </div>
  );
}
